import React, { useMemo, useState } from 'react';

import { Modal, Button } from 'semantic';
import { ConfigureConnectors } from 'components/ConfigureConnectors';

import modal from 'helpers/modal';
import { EvseController } from 'types/evse-controller';

type Props = {
  close: () => void;
  evseController: EvseController;
};

const EditEvseControllersConnectors = ({ close, evseController }: Props) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Modal.Header>Configure Connectors</Modal.Header>
      <Modal.Content>
        <ConfigureConnectors
          formId="edit-evse-controllers-connectors"
          evseController={evseController}
          onLoading={(loading: boolean) => setLoading(loading)}
          onSave={() => close()}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          disabled={loading}
          loading={loading}
          primary
          content={'Save'}
          form="edit-evse-controllers-connectors"
        />
      </Modal.Actions>
    </>
  );
};

export default modal(EditEvseControllersConnectors);
